/* =============================================================
   PRELOVERBOI — Theme JS
   Replaces React state + Framer Motion with vanilla equivalents.
   ============================================================= */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents) => 'RM ' + Math.round(cents / 100);

  /* ---------- TOASTS (replaces sonner) ---------- */
  let toastHost;
  function toast(msg) {
    if (!toastHost) {
      toastHost = document.createElement('div');
      toastHost.className = 'toast-host';
      document.body.appendChild(toastHost);
    }
    const el = document.createElement('div');
    el.className = 'toast';
    el.textContent = msg;
    toastHost.appendChild(el);
    setTimeout(() => {
      el.classList.add('leaving');
      setTimeout(() => el.remove(), 220);
    }, 3200);
  }
  window.plvbToast = toast;

  /* ---------- SCROLL REVEAL (mirrors useScrollReveal) ---------- */
  function initReveal() {
    const els = $$('.scroll-fade:not(.visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach((e) => e.classList.add('visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach((el) => io.observe(el));
  }

  /* ---------- HEADER SCROLL STATE ---------- */
  function initHeader() {
    const header = $('.site-header');
    if (!header) return;
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const toggle = $('.menu-toggle');
    const menu = $('.mobile-menu');
    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const open = menu.classList.toggle('open');
        document.body.style.overflow = open ? 'hidden' : '';
        $('.icon-menu', toggle).classList.toggle('hide', open);
        $('.icon-close', toggle).classList.toggle('hide', !open);
      });
    }
  }

  /* ---------- CART DRAWER ---------- */
  const Cart = {
    open() {
      $('.cart-drawer') && $('.cart-drawer').classList.add('open');
      $('.cart-backdrop') && $('.cart-backdrop').classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    close() {
      $('.cart-drawer') && $('.cart-drawer').classList.remove('open');
      $('.cart-backdrop') && $('.cart-backdrop').classList.remove('open');
      document.body.style.overflow = '';
    },
    async refresh() {
      const res = await fetch('/?section_id=cart-drawer');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('.cart-drawer-content', doc);
      const host = $('.cart-drawer-content');
      if (fresh && host) host.innerHTML = fresh.innerHTML;
      this.bind();
      const cart = await (await fetch('/cart.js')).json();
      this.updateBadge(cart.item_count);
    },
    updateBadge(count) {
      const btn = $('.js-cart-btn');
      if (!btn) return;
      let badge = $('.badge-count', btn);
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'badge-count';
          btn.appendChild(badge);
        }
        badge.textContent = count;
        badge.style.animation = 'none';
        void badge.offsetWidth;
        badge.style.animation = '';
      } else if (badge) {
        badge.remove();
      }
    },
    async add(variantId, qty) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        toast(err.description || 'Could not add to bag.');
        return false;
      }
      await this.refresh();
      this.open();
      return true;
    },
    async change(line, quantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      });
      await this.refresh();
    },
    bind() {
      $$('.js-cart-close').forEach((b) => (b.onclick = () => this.close()));
      $$('.js-qty').forEach((b) => {
        b.onclick = () => this.change(Number(b.dataset.line), Number(b.dataset.qty));
      });
      $$('.js-cart-remove').forEach((b) => {
        b.onclick = () => this.change(Number(b.dataset.line), 0);
      });
    },
    init() {
      const btn = $('.js-cart-btn');
      if (btn) btn.onclick = (e) => { e.preventDefault(); this.open(); };
      const bd = $('.cart-backdrop');
      if (bd) bd.onclick = () => this.close();
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      this.bind();
    },
  };
  window.plvbCart = Cart;

  /* ---------- ADD TO CART BUTTONS ---------- */
  function initAddToCart() {
    $$('.js-add').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const id = btn.dataset.variant;
        if (!id) return;
        const label = $('.js-add-label', btn);
        const original = label ? label.textContent : '';
        btn.disabled = true;
        const ok = await Cart.add(id, 1);
        btn.disabled = false;
        if (ok) {
          btn.classList.add('added');
          if (label) label.textContent = btn.dataset.addedLabel || 'Added!';
          setTimeout(() => {
            btn.classList.remove('added');
            if (label) label.textContent = original;
          }, 1500);
        }
      });
    });
  }

  /* ---------- WISHLIST (localStorage, mirrors WishlistContext) ---------- */
  const WISH_KEY = 'plvb_wishlist';
  const Wish = {
    get() {
      try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch { return []; }
    },
    set(list) {
      try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch {}
      this.paintBadge(list.length);
    },
    has(handle) { return this.get().some((i) => i.handle === handle); },
    toggle(data) {
      const list = this.get();
      const idx = list.findIndex((i) => i.handle === data.handle);
      if (idx > -1) list.splice(idx, 1); else list.push(data);
      this.set(list);
      return idx === -1;
    },
    paintBadge(count) {
      const btn = $('.js-wish-btn');
      if (!btn) return;
      let badge = $('.badge-count', btn);
      if (count > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'badge-count'; btn.appendChild(badge); }
        badge.textContent = count;
      } else if (badge) badge.remove();
    },
    init() {
      this.paintBadge(this.get().length);
      $$('.js-wish').forEach((btn) => {
        const handle = btn.dataset.handle;
        if (this.has(handle)) btn.classList.add('is-saved');
        btn.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          const added = this.toggle({
            handle: handle,
            title: btn.dataset.title || '',
            image: btn.dataset.image || '',
            price: btn.dataset.price || '',
            vendor: btn.dataset.vendor || '',
          });
          btn.classList.toggle('is-saved', added);
          btn.classList.add('active');
          setTimeout(() => btn.classList.remove('active'), 400);
          const lbl = $('.js-wish-label', btn);
          if (lbl) lbl.textContent = added ? 'Saved' : 'Save';
        });
      });
      const host = $('#wishlist-render');
      if (host) this.render(host);
    },
    render(host) {
      const list = this.get();
      if (!list.length) { host.innerHTML = host.dataset.empty || ''; return; }
      host.innerHTML =
        '<div class="grid-products">' +
        list.map((p) => (
          '<div class="product-card"><a class="product-card-image-wrap" href="/products/' + p.handle + '">' +
          (p.image ? '<img class="pc-primary" src="' + p.image + '" alt="">' : '') +
          '</a><div class="pc-info"><div class="pc-row"><span class="pc-brand">' + p.vendor + '</span></div>' +
          '<h3 class="pc-name"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>' +
          '<div class="pc-foot"><span class="price-tag">' + p.price + '</span></div></div></div>'
        )).join('') +
        '</div>';
    },
  };
  window.plvbWish = Wish;

  function initShop() {
    if (initFacets()) return;
    initShopLegacy();
  }

  /* ---------- NATIVE SHOPIFY FILTERS (server-side, whole catalogue) ---------- */
  function initFacets() {
    const root = $('#plvb-collection');
    const form = $('.js-facet-form');
    if (!root || !form) return false;
    const sectionId = root.dataset.section;

    const panel = $('.filter-panel', root);
    const toggle = $('.js-filter-toggle', root);
    if (toggle && panel) toggle.onclick = () => panel.classList.toggle('open');

    const sortBtn = $('.js-sort-btn', root);
    const sortMenu = $('.sort-menu', root);
    if (sortBtn && sortMenu) {
      sortBtn.onclick = (e) => { e.stopPropagation(); sortMenu.classList.toggle('open'); };
      document.addEventListener('click', () => sortMenu.classList.remove('open'));
    }

    function buildUrl() {
      const price = $('.js-price', form);
      // A slider sitting at its maximum means "no price limit" — don't send the param.
      let restore = false;
      if (price && Number(price.value) >= Number(price.dataset.max)) { price.disabled = true; restore = true; }
      const params = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
      if (restore) price.disabled = false;
      const qs = params.toString();
      return form.getAttribute('action') + (qs ? '?' + qs : '');
    }

    async function render(url, append) {
      root.classList.add('is-loading');
      try {
        const res = await fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        if (append) {
          const incoming = doc.querySelector('.js-grid');
          const grid = $('.js-grid', root);
          const wrap = $('.js-more-wrap', root);
          if (incoming && grid) Array.from(incoming.children).forEach((c) => grid.appendChild(c));
          const nextWrap = doc.querySelector('.js-more-wrap');
          if (wrap) { if (nextWrap) wrap.innerHTML = nextWrap.innerHTML; else wrap.remove(); }
        } else {
          const fresh = doc.querySelector('#plvb-collection');
          if (fresh) root.innerHTML = fresh.innerHTML;
        }
        history.replaceState({}, '', url);
      } catch (e) {
        window.location.href = url; return;
      }
      root.classList.remove('is-loading');
      initFacets(); Wish.init(); initAddToCart(); initReveal();
    }

    form.addEventListener('change', (e) => {
      if (e.target.classList.contains('js-price')) return; // handled below
      render(buildUrl(), false);
    });

    const price = $('.js-price', form);
    const priceOut = $('.js-price-out', root);
    if (price) {
      if (priceOut) price.addEventListener('input', () => { priceOut.textContent = 'RM ' + price.value; });
      price.addEventListener('change', () => render(buildUrl(), false));
    }

    $$('.js-sort', root).forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      const input = $('.js-sort-input', form);
      if (input) input.value = a.dataset.sort;
      if (sortMenu) sortMenu.classList.remove('open');
      render(buildUrl(), false);
    }));

    const more = $('.js-load-more', root);
    if (more) more.addEventListener('click', (e) => {
      e.preventDefault();
      more.textContent = more.dataset.loading || 'Loading...';
      render(more.getAttribute('href'), true);
    });

    return true;
  }

  /* ---------- SHOP FILTERS + SORT ---------- */
  function initShopLegacy() {
    const bar = $('.filter-bar');
    if (!bar) return;
    const toggle = $('.js-filter-toggle');
    const panel = $('.filter-panel');
    if (toggle && panel) toggle.onclick = () => panel.classList.toggle('open');

    const sortBtn = $('.js-sort-btn');
    const sortMenu = $('.sort-menu');
    if (sortBtn && sortMenu) {
      sortBtn.onclick = (e) => { e.stopPropagation(); sortMenu.classList.toggle('open'); };
      document.addEventListener('click', () => sortMenu.classList.remove('open'));
    }

    const price = $('.js-price');
    const priceOut = $('.js-price-out');
    if (price && priceOut) {
      price.addEventListener('input', () => { priceOut.textContent = 'RM ' + price.value; });
      price.addEventListener('change', applyFilters);
    }

    $$('.js-facet').forEach((el) => el.addEventListener('click', () => {
      el.classList.toggle('active');
      applyFilters();
    }));

    const clear = $('.js-clear');
    if (clear) clear.onclick = () => {
      $$('.js-facet').forEach((el) => el.classList.remove('active'));
      if (price) { price.value = price.max; priceOut.textContent = 'RM ' + price.max; }
      applyFilters();
    };

    function applyFilters() {
      const cats = $$('.js-facet[data-facet="category"].active').map((e) => e.dataset.value.toLowerCase());
      const conds = $$('.js-facet[data-facet="condition"].active').map((e) => e.dataset.value.toLowerCase());
      // Slider sitting at its maximum means 'no price limit', so products priced
      // above the slider's range are never hidden with filters inactive.
      const max = price && Number(price.value) < Number(price.max) ? Number(price.value) : Infinity;
      let shown = 0;
      $$('.js-card').forEach((card) => {
        const cardKeys = (card.dataset.category || '').toLowerCase().split('|').map((k) => k.trim()).filter(Boolean);
        const cd = (card.dataset.condition || '').toLowerCase();
        const p = Number(card.dataset.price || 0);
        const okCat = !cats.length || cats.some((x) => x.split('|').map((k) => k.trim()).some((k) => cardKeys.includes(k)));
        const okCond = !conds.length || conds.includes(cd);
        const okPrice = p <= max;
        const show = okCat && okCond && okPrice;
        card.classList.toggle('hide', !show);
        if (show) shown++;
      });
      const count = $('.js-item-count');
      if (count) count.textContent = shown + ' Items';
      const active = cats.length + conds.length + (price && Number(price.value) < Number(price.max) ? 1 : 0);
      const badge = $('.js-active-count');
      if (badge) { badge.textContent = active; badge.classList.toggle('hide', active === 0); }
      const clearBtn = $('.js-clear');
      if (clearBtn) clearBtn.classList.toggle('hide', active === 0);
      const empty = $('.js-empty');
      if (empty) empty.classList.toggle('hide', shown !== 0);
    }
    applyFilters();
  }

  /* ---------- PDP GALLERY ---------- */
  function initPdp() {
    const main = $('.js-pdp-img');
    if (!main) return;
    $$('.js-pdp-thumb').forEach((t) => {
      t.onclick = () => {
        $$('.js-pdp-thumb').forEach((x) => x.classList.remove('active'));
        t.classList.add('active');
        main.style.opacity = '0';
        setTimeout(() => { main.src = t.dataset.full; main.style.opacity = '1'; }, 150);
      };
    });
    const share = $('.js-share');
    if (share) share.onclick = async () => {
      const payload = { title: document.title, url: window.location.href };
      if (navigator.share) { try { await navigator.share(payload); return; } catch {} }
      try { await navigator.clipboard.writeText(window.location.href); toast('Link copied!'); } catch { toast('Link copied!'); }
    };
    const sel = $('.js-variant');
    if (sel) sel.addEventListener('change', () => {
      const opt = sel.options[sel.selectedIndex];
      const btn = $('.js-add-main');
      if (btn) {
        btn.dataset.variant = opt.value;
        btn.disabled = opt.dataset.available === 'false';
      }
      const pr = $('.js-price-main');
      if (pr && opt.dataset.price) pr.textContent = opt.dataset.price;
    });
  }

  /* ---------- COUNTDOWN ---------- */
  function initCountdown() {
    $$('.js-countdown').forEach((el) => {
      const target = new Date(el.dataset.target).getTime();
      const tick = () => {
        const diff = target - Date.now();
        if (diff <= 0) { el.innerHTML = '<span class="cd-val">LIVE</span>'; return; }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        const pad = (n) => String(n).padStart(2, '0');
        el.innerHTML = [['Days', d], ['Hrs', h], ['Min', m], ['Sec', s]]
          .map(([l, v]) => '<div class="cd-unit"><span class="cd-val">' + pad(v) + '</span><span class="cd-lbl">' + l + '</span></div>')
          .join('');
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- MAGNETIC BUTTON ---------- */
  function initMagnetic() {
    if (window.matchMedia('(hover: none)').matches) return;
    $$('.btn-magnetic').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + x * 0.18 + 'px,' + y * 0.18 + 'px)';
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* ---------- BOOT ---------- */
  function boot() {
    initReveal(); initHeader(); Cart.init(); initAddToCart();
    Wish.init(); initShop(); initPdp(); initCountdown(); initMagnetic();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
